import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import Img01 from "../../images/services/ac/Efficiency-improvement.webp";
import Img02 from "../../images/services/ac/Process-optimization.webp";
import Img03 from "../../images/services/ac/Cost-reduction.webp";
import Img04 from "../../images/services/ac/Workflow-automation.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Servicespartner(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="App Consultan">
                            <h2>Your Business Partner For End-To-End Automation Consulting</h2>
                        </div>
                        <h5 className="strong">Think boldly about business agility, growth, and scalability
                            possibilities – think TekRevol.</h5>
                        <p>We do more than technically develop powerful web, app, and SaaS experiences for our
                            stakeholders – we identify priority areas and contribute to industrial disruption. To bring
                            all of our commitments to successful digital realities, we offer intelligent automation
                            consulting and put our best human resources in charge to deliver substantial automation
                            value.</p>
                        <p>Want to take an insider look into how we do what we do?</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-lg-5 offset-lg-1">
                        <Row>
                            <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                                <div className="set_of_images hover01">
                                    <LazyLoadImage
                                        src={Img01}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Efficiency Improvement</p>
                                </div>
                                <div className="set_of_images hover01 mt-4">
                                    <LazyLoadImage
                                        src={Img03}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Cost Reduction</p>
                                </div>
                            </Col>
                            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-lg-4 mt-md-0">
                                <div className="set_of_images hover01">
                                    <LazyLoadImage
                                        src={Img02}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Process Optimization</p>
                                </div>
                                <div className="set_of_images hover01  mt-4">
                                    <LazyLoadImage
                                        src={Img04}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Workflow Automation</p>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Servicespartner;